import * as React from 'react';
import { ListGroupItem, Panel, Alert } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import ProductPropertiesIcons from '../../propertyIcons/ProductPropertiesIcons';
import PhotographerUploadBoxes from './PhotographerUploadBoxes';
import { IOrderRow } from '../Entities';
import { UserRole } from '../../../shared/types';
import * as ProductProperty from '../../../shared/ProductProperties';

interface IState {
    filesAdded: number;
}

interface IProps {
    orderRow: IOrderRow;
    orderId: number;
    upload: boolean;
    user: any;
    updateTotalBytes: (bytes: number) => void;
    updateProgress: (bytes: number, fileName: string, orderRowId: number, type: number) => void;
    addFileToMetadataList: (orderRowId: number, category: number, fileName: string) => void;
    removeFileFromMetadataList: (orderRowId: number, category: number, fileName: string) => void;
    toggleDragging: (dragging: boolean) => void;
    setOrderRowIdUploadDone: (id: number) => void;
    orderRowProductProperties: any[];
    onUploadDone: (anyUploads: boolean) => void;
    setOrderRowIdAllFilesProcessed?: (orderRowId: number) => void;
}

const productsToExclude = [ProductProperty.BlueSky, ProductProperty.InteriorBlueSky];

class ProductPicturesRow extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            filesAdded: 0
        };

        this.updateFilesAdded = this.updateFilesAdded.bind(this);
    }

    updateFilesAdded(filesAdded: number) {
        this.setState({ filesAdded: filesAdded } as IState);
    }

    render() {

        const userRole = this.props.user.details.role;
        
        return (
            <ListGroupItem>
                <div className="loading">
                    <div className="row">
                        <div className="col-md-6">
                            <h3>
                                {Translate('photographer-uploads/order/row/product')}:{' '}
                                {this.props.orderRow.product.name}{' '}
                                <ProductPropertiesIcons
                                    properties={userRole == UserRole.Photographer
                                        ? this.props.orderRowProductProperties.filter((property) => {
                                            return property.value !== productsToExclude.find((x) => x === property.value);
                                        })
                                        : this.props.orderRowProductProperties}
                                ></ProductPropertiesIcons>
                            </h3>
                        </div>
                        <div className="col-md-6">
                            <span className="pull-right">
                                {Translate('photographer-uploads/order/row/files-added')}:{' '}
                                {this.state.filesAdded +
                                    this.props.orderRow.product.numberOfImagesUploaded}
                                /{this.props.orderRow.product.numberOfImages}
                            </span>
                        </div>
                    </div>

                    {this.props.orderRow.product.photographerInstructions && (
                        <Alert bsStyle="info">
                            <strong>
                                {Translate('photographer-uploads/order/row/instructions')}:
                            </strong>{' '}
                            {this.props.orderRow.product.photographerInstructions}
                        </Alert>
                    )}

                    <PhotographerUploadBoxes
                        orderId={this.props.orderId}
                        orderRowId={this.props.orderRow.id}
                        upload={this.props.upload}
                        toggleDragging={this.props.toggleDragging}
                        updateTotalBytes={this.props.updateTotalBytes}
                        updateProgress={this.props.updateProgress}
                        updateFilesAdded={this.updateFilesAdded}
                        onUploadDone={this.props.onUploadDone}
                        setOrderRowIdUploadDone={this.props.setOrderRowIdUploadDone}
                        addFileToMetadataList={this.props.addFileToMetadataList}
                        removeFileFromMetadataList={this.props.removeFileFromMetadataList}
                        hideNormalUploadBox={this.props.orderRow.hasFlex}
                        hideNoDeliveryUploadBox={this.props.orderRow.hasFlex}
                        setOrderRowIdAllFilesProcessed={this.props.setOrderRowIdAllFilesProcessed}
                        isPhotographerUploadPage={true}
                        uploadDNG={true}
                    />
                </div>
            </ListGroupItem>
        );
    }
}

export default ProductPicturesRow;
